module.exports = __webpack_public_path__ + "media/images/pen_lightgreen-44013ba3.png";